<template>
  <div>
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
            <el-form-item label="司机姓名:">
              <el-input  placeholder="" v-model="searchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" >
              <el-input  placeholder="" v-model="searchFrom.driverPhone"></el-input>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
            </el-form-item>
            <el-form-item label="车辆类型:" prop="vhcTypeId" >
                <el-select placeholder="请选择" v-model="searchFrom.vhcTypeId">
                  <el-option
                    v-for="item in vehicleT"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
             <br>
            <el-form-item label="能源类型:" prop="energyId">
                <el-select placeholder="请选择" v-model="searchFrom.energyId">
                  <el-option
                    v-for="item in NYtype"
                    :key="item.id"
                    :label="item.energyName"
                    :value="item.id"
                  ></el-option>
                </el-select>
             </el-form-item>
            <el-form-item label="报号时间:">
              <el-date-picker
                v-model="searchFrom.queueTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                   :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="009M0I0100">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item btnCode="009M0I0300">
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" @row-click="handleRowClick"    bordersize="mini" class="tableComent" height="100%" style="width: 100%" center border >
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column label="操作"  width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="zuofeiFn(scope.row)">作废</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="driverName" min-width="130" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column prop="driverPhone" min-width="130" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column prop="vhcNo" min-width="130" :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column prop="vhcTypeName" min-width="140" :formatter="emptyFn" label="车辆类型"></el-table-column>
        <el-table-column prop="energyName" min-width="90" :formatter="emptyFn" label="能源类型"></el-table-column>
        <el-table-column prop="queueTime" min-width="170" label="报号时间" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
     <!-- 作废 -->
    <el-dialog  title="作废" :close-on-click-modal="false" :close-on-press-escape="false"  @close="ZFflag = false"  :visible.sync="ZFflag" width="400px" center>
      <div>
        <el-form  :inline="true"  ref="ZFform" :model="ZFform"  class="demo-form-inline"  label-width="80px"  size="mini"  >
          <el-form-item label="作废原因:" class="item1" prop="remark">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="ZFform.remark" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ZFflag = false">取 消</el-button>
        <el-button type="primary" @click="ZFsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { cDriverQueueList, cVTlist, cVhcEnergyTypeList, cDriverQueueInvalid } from '@/api/vgs-driver2.0'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisable: false,
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: false,
      vehicleT: [],
      NYtype: [],
      ZFform: {},
      ZFflag: false,
      btnFlg: [],
      btnIdArr: ['00IM0F0100', '00IM0F0200']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shiftScheduling')
    cVTlist({}).then(res => {
      this.vehicleT = res
      this.vehicleT.unshift({ id: '', name: '请选择' })
    })
    cVhcEnergyTypeList({}).then(res => {
      this.NYtype = res
      this.NYtype.unshift({ id: '', energyName: '请选择' })
    })
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 205) + 'px'
  },
  methods: {
    // 作废
    zuofeiFn (row) {
      this.ZFform.queueId = row.id
      this.ZFform.status = 3
      this.ZFflag = true
    },
    ZFsaveFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDriverQueueInvalid(this.ZFform).then(res => {
        loading.close()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        this.ZFflag = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 导出
    exportFn () {
      let form = this.searchFrom
      exportExcel(
        this.global.orderName + '/exceptionReporting/exportInventoryList',
        form,
        '异常风险列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      if (this.rosterDate) {
        this.searchFrom.startTime = this.rosterDate[0]
        this.searchFrom.endTime = this.rosterDate[1]
      } else {

      }
      searchFrom.status = 0
      cDriverQueueList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.rosterDate = []
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    }
  }
}
</script>
<style scoped lang='less'>

/deep/.el-form{
  width: 100%;
}
/deep/.searchBox .el-input--mini .el-input__inner{
  width: 150px !important;
}
.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
      width: 160px;
      height: 160px;
      list-style: none;
      margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
 }
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
